import { render, staticRenderFns } from "./otherwork.vue?vue&type=template&id=3a679ae2&scoped=true"
import script from "./otherwork.vue?vue&type=script&lang=js"
export * from "./otherwork.vue?vue&type=script&lang=js"
import style0 from "./otherwork.vue?vue&type=style&index=0&id=3a679ae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a679ae2",
  null
  
)

export default component.exports